/* 🤖 this file was generated by svg-to-ts */
export const matIconSubscript: {
  name: 'subscript';
  data: string;
} = {
  name: 'subscript',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 18h-2v1h3v1h-4v-2c0-.55.45-1 1-1h2v-1h-3v-1h3c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zM5.88 18h2.66l3.4-5.42h.12l3.4 5.42h2.66l-4.65-7.27L17.81 4h-2.68l-3.07 4.99h-.12L8.85 4H6.19l4.32 6.73L5.88 18z"/></svg>`
};
